<script setup lang="ts">
    import { computed } from 'vue'
    import { useRoute } from 'vue-router'
    import { dynamicUiRoutes } from '@common/dynamicUiRoutes'

    // ---------------- props ----------------
    // keep original prop names – template relies on them

    const props = defineProps<{
        WorkspaceId: number
        ProjectId: number
        EvalModelId: number
        ScoringEnabled: boolean
        ActivePage: string
    }>()

    // ---------------- routing ----------------

    const route = useRoute()

    // ---------------- derived (urls) ----------------

    const url_CriteriaPage = computed(() =>
        dynamicUiRoutes.Criteria_CriteriaPage(
            route,
            props.WorkspaceId,
            props.ProjectId,
            props.EvalModelId
        )
    )

    const url_RankingPage = computed(() =>
        dynamicUiRoutes.Evaluation_RankingPage(
            route,
            props.WorkspaceId,
            props.ProjectId,
            props.EvalModelId
        )
    )

    const url_WeightsPage = computed(() =>
        dynamicUiRoutes.Criteria_WeightsPage(
            route,
            props.WorkspaceId,
            props.ProjectId,
            props.EvalModelId
        )
    )

    const url_MeasurementsPage = computed(() =>
        dynamicUiRoutes.Criteria_MeasurementsPage(
            route,
            props.WorkspaceId,
            props.ProjectId,
            props.EvalModelId,
            props.ScoringEnabled
        )
    )

    const url_WeightedScoresPage = computed(() =>
        dynamicUiRoutes.Criteria_WeightedScoresPage(
            route,
            props.WorkspaceId,
            props.ProjectId,
            props.EvalModelId
        )
    )

    const url_ScoringPanelsPage = computed(() =>
        dynamicUiRoutes.Evaluation_ScoringPanelsPage(
            route,
            props.WorkspaceId,
            props.ProjectId,
            props.EvalModelId
        )
    )
</script>


<template>
    <div>
        <ul class="nav nav-pills">
            <li class="nav-item" :class="{'active2': ActivePage === 'criteria-hierarchy'}">
                <a class="nav-link" v-sanitizedHref="url_CriteriaPage">
                    Criteria
                </a>
            </li>
            <li class="nav-item" :class="{'active2': ActivePage === 'measurement'}">
                <a class="nav-link" v-sanitizedHref="url_MeasurementsPage">
                    Measurement
                </a>
            </li>
            <li class="nav-item" :class="{'active2': ActivePage === 'criteria-surveys'}">
                <a class="nav-link" v-sanitizedHref="url_WeightsPage">
                    Weights
                </a>
            </li>
            <li class="nav-item" v-if="ScoringEnabled" :class="{'active2': ActivePage === 'scoring-surveys'}">
                <a class="nav-link" v-sanitizedHref="url_ScoringPanelsPage">
                    Scoring
                </a>
            </li>
            <li class="nav-item" v-if="!ScoringEnabled" :class="{'active2': ActivePage === 'weighted-scores'}">
                <a class="nav-link" v-sanitizedHref="url_WeightedScoresPage">
                    Scores
                </a>
            </li>

            <li class="nav-item" :class="{'active2': ActivePage === 'results'}">
                <a class="nav-link" v-sanitizedHref="url_RankingPage">
                    Ranking
                </a>
            </li>
        </ul>
        <hr style="border-color: #bbb; margin: 0 0 60px;" />
    </div>
</template>

<style scoped>
    .nav-pills li a {
        border-radius: 0;
        color: black;
        background-color: transparent;
    }

        .nav-pills li a:hover {
            color: gray;
        }


    .nav-pills li.active2 {
        border-bottom: 3px solid blue;
    }

        .nav-pills li.active2 a {
            color: blue;
        }
</style>